import Vue from "vue";
import App from "./App.vue";
import RequestConfig from "./utils/request";
import { getLocalStorage, setLocalStorage, newGuid } from "./utils/util";
import router from './router';
import i18n from './i18n'; // 导入 i18n 配置
// import VConsole from "vconsole";

// new VConsole();

Vue.config.productionTip = false;

var deviceInfo = {};
var tokenKey = "palm_h5_token";
if (window.android && window.android.getAppDeviceInfo) {
  deviceInfo = JSON.parse(window.android.getAppDeviceInfo() || "{}");
  setLocalStorage("deviceInfo", deviceInfo);
  console.log("deviceInfo :>> ", deviceInfo);
}
var token = deviceInfo.gaid || getLocalStorage(tokenKey);
if (!token) {
  token = newGuid();
  setLocalStorage(tokenKey, token);
}

// 设置 1rem = 100px（方便计算，如 1.2rem = 120px）
document.documentElement.style.fontSize = window.innerWidth / 7.5 + "px";
// 监听窗口变化
window.addEventListener("resize", () => {
  document.documentElement.style.fontSize = window.innerWidth / 7.5 + "px";
});
// console.log("window.innerWidth", window.innerWidth);
// token = "6393a83c-3fd4-9b98-a027-67a89ab4dc48";
// token = "2c5c5fb4-93f6-4b36-b6ec-2ddafffc8eae";
// token = "d72265c6-6a2d-4370-9abd-5ef143d1012b";
Vue.prototype.$token = token;
console.log("token :>> ", token);
Vue.prototype.$requestConfig = new RequestConfig(token);

new Vue({
  router,
  i18n, // 注入到 Vue 实例
  render: h => h(App)
}).$mount("#app");
